import AccountMenuHeader from './AccountMenuHeader.jsx'

export function AccountMenuHeaderSlot({ accountFullName, accountEmail }) {
  return <AccountMenuHeader accountFullName={accountFullName} accountEmail={accountEmail} />
}
